// extracted by mini-css-extract-plugin
module.exports = {"indicator":"indicator__PMMm-","question-number":"question-number__f3NHf","separator":"separator__1kUx_","total-questions":"total-questions__3bTuB"};